const getters = {
    getMappedSubarrays: state => (site) => {
      const trackers = state.trackers.trackers;
      if (trackers.length === 0) return;

      const siteTrackers = trackers.filter((tracker) => tracker.site_id === site);
  
      const subarrays = {};
      siteTrackers.forEach((tracker) => {
        if (tracker && tracker.coords) {
          if (subarrays[tracker.sub_array_id]) {
            subarrays[tracker.sub_array_id].push(tracker);
          } else {
            subarrays[tracker.sub_array_id] = [tracker];
          }
        }
      });
  
      return subarrays;
    },
    getUnmappedSubarrays: state => (site) => {
        const gcus = state.gcus.gcus;
        const trackers = state.trackers.trackers;
        if (gcus.length === 0 || trackers.length === 0) return;
  
        const siteGcus = gcus.filter((g) => g.site_id === site);
        const siteTrackers = trackers.filter((tracker) => tracker.site_id === site);
  
        const subarrays = {};
        siteGcus.forEach(gcu => {
            const gcuTrackers = siteTrackers.filter((t) => t.gcu_code === gcu.code);
            if (gcuTrackers.length > 0) {
                const unmappedTrackers = gcuTrackers.filter((t) => !t.coords );
                if (unmappedTrackers.length > 0)
                    subarrays[gcu.code] = unmappedTrackers;
            } else {
                subarrays[gcu.code] = [];
            }
        });

        return subarrays;
    }
  };

  import trackers from './trackers.module';
  import gcus from './gcus.module';
  export default {
    namespaced: true,
    getters,
    modules: {
        gcus,
        trackers
    },
  };
  